module.exports = __webpack_public_path__ + "img/bg-login.17fc1f75.png";